// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as N_RnrAssetConfig from "./N_RnrAssetConfig.bs.js";

var claimed_points_card_thumbnail_images_1 = {
  hd: N_RnrAssetConfig.porter_coin,
  tl: {
    hd: N_RnrAssetConfig.porter_coin,
    tl: {
      hd: N_RnrAssetConfig.porter_coin,
      tl: {
        hd: N_RnrAssetConfig.porter_coin,
        tl: /* [] */0
      }
    }
  }
};

var claimed_points_card_thumbnail_images = {
  hd: N_RnrAssetConfig.porter_coin,
  tl: claimed_points_card_thumbnail_images_1
};

var learn_more_videos_0 = {
  thumbnail_image: N_RnrAssetConfig.learn_more_video_thumbnail_1,
  title: "Watch the video to learn more!",
  url: "https://www.youtube.com/embed/x6QAIpTwhoI?si=-YMKXfGwWtJ7Aq0C&fs=0&rel=0&autoplay=1&modestbranding=1"
};

var learn_more_videos = {
  hd: learn_more_videos_0,
  tl: /* [] */0
};

var learn_more_content = "\n  * Every Login hour (9am to 9pm) = ![porter_coin](" + N_RnrAssetConfig.porter_coin + ") 5\n  \n  * Every completed order = ![porter_coin](" + N_RnrAssetConfig.porter_coin + ") 50\n\n  * Every 5-STAR Rating = ![porter_coin](" + N_RnrAssetConfig.porter_coin + ") 50\n\n  * Claim points everyday- unclaimed points will expire in 24 hours\n\n  * 0 order cancellation allowed. You will get 0 completed order points in case of order cancellation.\n  ";

var rnr_2w_api_hostname = Config.Env.getRnrHostName(undefined);

var week_interval_format = "D MMM";

var announcement_date_format = "ddd Do MMM";

var general_date_format = "YYYY-MM-DD";

var rnr_2w_api_path = "/api/v1/rnr/drivers/";

var rnr_2w_report_path = "/rnr_report_for_two_wheeler/";

var rnr_2w_config_path = "/rnr_config";

var rnr_2w_claim_path = "/rewards?lang=";

var reward_category_em_error_path = "N_RewardCategory.res";

var reward_category_em_error_message = "category name cannot be mapped to a valid category type";

var reward_status_em_error_path = "N_RewardStatus.res";

var reward_status_em_error_message = "Unexpected reward status";

var reward_type_em_error_path = "N_RewardType.res";

var reward_type_em_error_message = "No expected reward type found";

export {
  claimed_points_card_thumbnail_images ,
  learn_more_videos ,
  learn_more_content ,
  week_interval_format ,
  announcement_date_format ,
  general_date_format ,
  rnr_2w_api_hostname ,
  rnr_2w_api_path ,
  rnr_2w_report_path ,
  rnr_2w_config_path ,
  rnr_2w_claim_path ,
  reward_category_em_error_path ,
  reward_category_em_error_message ,
  reward_status_em_error_path ,
  reward_status_em_error_message ,
  reward_type_em_error_path ,
  reward_type_em_error_message ,
  
}
/* rnr_2w_api_hostname Not a pure module */
